import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-800 mb-8 text-center">
            Terms & Conditions
          </h1>

          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              By accessing the Trademark Law Associates website (referred to as
              the "Site"), you acknowledge and accept the terms and conditions
              outlined herein, forming an agreement between you and Trademark
              Law Associates (referred to as "we," "us," or "our"). This
              agreement also incorporates our Privacy Policy as if fully stated
              here. If you do not agree with these terms, please refrain from
              using the Site. We offer general information related to trademarks
              and provide a platform where you can prepare and file trademarks.
            </p>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
              <p className="text-gray-800 font-semibold">
                THIS AGREEMENT INCLUDES A MANDATORY ARBITRATION CLAUSE GOVERNED
                BY THE FEDERAL ARBITRATION ACT, AND A WAIVER OF CLASS ACTIONS.
              </p>
            </div>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Conditions for Use of the Site
            </h2>
            <p className="text-gray-600 mb-4">
              Your access to and use of the Site is contingent upon your
              acceptance and adherence to these terms. By using the Site, you
              agree that you:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Will comply with these Terms of Service;</li>
              <li>Are 18 years of age or older;</li>
              <li>
                Will not use the Site in any way that violates U.S. laws,
                including its export and re-export regulations;
              </li>
              <li>
                Will not copy or distribute any content from the Site without
                our prior written consent;
              </li>
              <li>
                Will provide accurate details when registering, submitting
                content, or interacting with the Site;
              </li>
              <li>
                Will not permit others to use the Site under your user
                credentials;
              </li>
              <li>
                Are fully responsible for all activity under your account and
                user credentials;
              </li>
              <li>
                Will not use the Site for commercial purposes other than those
                expressly stated;
              </li>
              <li>
                Will not use the Site to collect personal information about
                others or solicit users or advertisers;
              </li>
              <li>
                Are solely responsible for any content you submit to the Site,
                ensuring you have the rights or licenses to do so, and will not
                upload any materials infringing on others' copyrights or
                proprietary rights;
              </li>
              <li>
                Grant us and other users a non-exclusive license to use,
                display, reproduce, distribute, or create derivative works from
                your submitted materials; and
              </li>
              <li>
                Agree that we may remove any of your content and suspend or
                terminate your account, with or without prior notice.
              </li>
            </ul>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Your Content
            </h2>
            <p className="text-gray-600 mb-4">
              We reserve the right to publish any content you provide (referred
              to as "User-Generated Content" or "UGC"). You agree not to upload
              or use any UGC that:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>
                Violates the intellectual property rights of others, including
                copyright, trademarks, or trade secrets;
              </li>
              <li>
                Infringes on privacy or publicity rights of any third party;
              </li>
              <li>
                Is unlawful, inaccurate, defamatory, discriminatory, obscene, or
                harassing;
              </li>
              <li>Encourages criminal activity or civil liability;</li>
              <li>Is deemed inappropriate by us, in our sole discretion; or</li>
              <li>Could harm our company, affiliates, or partners.</li>
            </ul>
            <p className="text-gray-600 mb-6">
              We are not obligated to remove UGC violating these terms, but we
              reserve the right to do so at our discretion, and may take further
              action such as account termination. We are not liable for any harm
              caused by UGC.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Your Behavior
            </h2>
            <p className="text-gray-600 mb-4">
              By using the Site, you agree not to:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>Engage in or promote illegal activities;</li>
              <li>
                Attempt to reverse engineer or disrupt the Site's functionality;
              </li>
              <li>Attempt to access restricted areas of the Site;</li>
              <li>Use the Site for unsolicited email campaigns or spam;</li>
              <li>
                Use automated tools to scrape or collect data from the Site;
              </li>
              <li>Interfere with the proper functioning of the Site;</li>
              <li>Impersonate another user.</li>
            </ul>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Links to Third-Party Sites
            </h2>
            <p className="text-gray-600 mb-6">
              Our Site may contain links to third-party websites not controlled
              by us. We assume no responsibility for the content or practices of
              these external sites. Linking to these sites does not imply
              endorsement by us.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Termination
            </h2>
            <p className="text-gray-600 mb-6">
              We reserve the right to modify or discontinue the Site or any
              services provided without prior notice. Additionally, we may
              terminate this agreement for any reason, with or without notice.
              If we terminate your access due to violations of these terms, you
              will immediately lose access to the Site. The clauses related to
              warranties, liabilities, indemnity, dispute resolution, and your
              content will survive the termination of this agreement.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Displaying Data and Search Features
            </h2>
            <p className="text-gray-600 mb-6">
              We may use official government records and display them on the
              Site. While we strive to ensure accuracy, we do not guarantee that
              the information is up-to-date or error-free.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Calendar Reminders
            </h2>
            <p className="text-gray-600 mb-6">
              We may offer reminders about specific trademark deadlines as part
              of our services. These reminders are for general informational
              purposes and may not apply to your unique circumstances. We
              recommend consulting with a licensed attorney regarding deadlines
              specific to your situation.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Credit Card Information
            </h2>
            <p className="text-gray-600 mb-6">
              We may store your credit card details only for the purpose of
              paying the filing fees associated with your order, provided you
              approve the application and are aware of the costs involved.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Search Services
            </h2>
            <p className="text-gray-600 mb-6">
              If you use our search services, we employ reasonable methods to
              identify potential matches to the trademarks you wish to use.
              However, we cannot guarantee that your trademark will be approved
              by the USPTO or that it will not face challenges, even with our
              search services. There are cases where automated searches may not
              identify conflicts that could result in rejection by the USPTO.
              Similarly, for common law mark searches, while we use commercially
              reasonable methods to find potential matches, we cannot guarantee
              that all common law claims will be identified.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Trademark Search Scope
            </h2>
            <p className="text-gray-600 mb-4">
              Our Trademark Law Associates trademark search services include:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-6 space-y-2">
              <li>
                <strong>Federal Search:</strong> Reviews the USPTO database and
                includes direct matches, phonetic similarities, or visual design
                similarities.
              </li>
              <li>
                <strong>Federal, State, and Common Law Search:</strong> Extends
                to all 50 states, a business registry, and domain name
                databases, including matches in phonetics, design, or
                translation.
              </li>
              <li>
                <strong>Global Search:</strong> Includes the USPTO database,
                state databases, business registries, domain name databases, the
                WIPO database, and the European Community database, focusing on
                direct matches, phonetic similarities, or visual design
                likenesses.
              </li>
            </ul>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Trademark Monitoring Services
            </h2>
            <p className="text-gray-600 mb-6">
              Our trademark monitoring service reviews the filing of new
              applications that are direct matches, phonetically similar,
              similar in terms of translation, or appearance by way of design to
              your marks as published in the Official Gazette of the USPTO and
              Trademark Law Associates.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Subscription and Auto-Renewals
            </h2>
            <p className="text-gray-600 mb-6">
              If you signed up for one or more subscription services through the
              Website, these additional terms apply. Your license to the
              Services is valid during the period your subscription remains in
              good standing and there are no outstanding subscription payments
              (hereinafter "Subscription Term"). To keep your Subscription Term
              valid and in force, you must pay all charges to your account
              relating to your subscriptions, including applicable taxes and
              fees. Unless otherwise provided, your Subscription Term is on an
              automatic renewal and you will be required to pay, through the
              credit card provided by you, for the next applicable Subscription
              Term at the beginning of the Subscription Term period. These
              charges are applied regardless of whether you continue to use the
              Services during the Subscription Term. YOU ARE RESPONSIBLE FOR
              SUBSCRIPTION FEES UNTIL YOU CANCEL YOUR SUBSCRIPTION OR IT IS
              OTHERWISE TERMINATED.
            </p>
            <p className="text-gray-600 mb-6">
              If your Subscription Term is month to month and your purchase date
              is on the 29th through 31st day of any month, your renewal date
              will fall on the last day of the month for any succeeding months
              with fewer days. Unless otherwise provided, the renewal period
              will be the same as the price you originally paid. We may offer
              promotional trial memberships. Although the promotional trial
              membership may be advertised as free promotional memberships, you
              authorize us to charge your credit card $1 to confirm the source
              of the payment. AT THE END OF A TRIAL OR PROMOTIONAL MEMBERSHIP,
              UNLESS OTHERWISE STATED IN THE OFFER OR YOU CANCEL, YOUR
              SUBSCRIPTION WILL RENEW AUTOMATICALLY AND YOUR CREDIT CARD WILL BE
              CHARGED TO BEGIN YOUR INITIAL SUBSCRIPTION TERM.
            </p>
            <p className="text-gray-600 mb-6">
              It is very important to understand that you will not receive a
              notice from us that your free trial has ended and that payment for
              your subscription is due. We may discontinue offering
              subscriptions and will cease charging you accordingly. We may also
              terminate your Subscription in our sole discretion subject to your
              right to a pro-rated refund of fees. We may increase subscription
              fees and/or terms with 30 days' notice to you. You may terminate
              your services before the increase in fees or renewal terms is put
              into effect. If you do not cancel, you will be charged the new
              rate at the time of the renewal of your Subscription Term the
              increased amount and/or your renewed Subscription Term will be the
              new applicable length.
            </p>
            <p className="text-gray-600 mb-6">
              To cancel your subscription, contact us at
              info@trademarklawassociates.com. After you have cancelled, your
              subscription and account will remain active through the end of the
              then current Subscription Term. After termination, you may not
              have access to your account or the Services related to your
              subscription.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              New Services/Features
            </h2>
            <p className="text-gray-600 mb-6">
              From time to time, we may offer new services and/or features
              through the website (including, the release of new tools and
              resources). Such new features and/or services shall also be
              subject to these Terms of Service.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Disclaimers of Warranty and Limitations of Liability
            </h2>
            <p className="text-gray-600 mb-6">
              We provide the Website and the related services "as is", "where
              is", and "as available." We make no express and/or implied
              warranties or guarantees about the Website, the goods and services
              described thereon or the Advertisers. TO THE MAXIMUM EXTENT
              PERMITTED BY LAW, WE AND OUR OFFICERS, DIRECTORS, AGENTS, VENDORS,
              AND THE MERCHANTS WHO ADVERTISE WITH US DISCLAIM ANY AND ALL
              EXPRESS OR IMPLIED WARRANTIES THAT THE WEBSITE AND SERVICES ARE
              MERCHANTABLE, OF SATISFACTORY QUALITY, ACCURATE, TIMELY OR FIT FOR
              A PARTICULAR PURPOSE OR NEED.
            </p>
            <p className="text-gray-600 mb-6">
              WE IN NO WAY GUARANTEE THAT WE WILL MEET YOUR REQUIREMENTS, IS
              ERROR-FREE, ACCURATE, RELIABLE, WITHOUT INTERRUPTION OR AVAILABLE
              AT ALL TIMES. WE MAKE NO GUARANTEE THAT YOU WILL BE ABLE TO ACCESS
              OR USE THE WEBSITE AT TIMES OR LOCATIONS OF YOUR CHOOSING. YOUR
              SOLE AND EXCLUSIVE REMEDY FOR ANY DISPUTE OR CLAIM WITH US IS TO
              CEASE USE OF THE WEBSITE.
            </p>
            <p className="text-gray-600 mb-6">
              WE, OUR AFFILIATES, OFFICERS, DIRECTORS, AGENTS, VENDORS, AND
              MERCHANTS WHO ADVERTISE HERE, SHALL NOT BE LIABLE FOR ANY
              INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES
              ARISING FROM YOUR USE OF, INABILITY TO USE, OR RELIANCE UPON THE
              WEBSITE IN ANY WAY. THESE EXCLUSIONS APPLY TO ANY CLAIMS FOR LOST
              PROFITS, LOST DATA, LOSS OF GOODWILL, WORK STOPPAGE, COMPUTER
              FAILURE OR MALFUNCTION, DAMAGE TO ANY OTHER EQUIPMENT, OR ANY
              OTHER COMMERCIAL DAMAGES OR LOSSES, EVEN IF WE KNEW OR SHOULD HAVE
              KNOWN OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Indemnity
            </h2>
            <p className="text-gray-600 mb-6">
              You agree to defend, indemnify and hold harmless us, our officers,
              directors, representatives, employees and agents and all of our
              parent companies, affiliates, related companies and their
              officers, directors, representatives, employees and agents from
              and against any and all claims, damages, obligations, losses,
              liabilities, costs or debt, and expenses (including but not
              limited to reasonable attorney's fees) arising from: (i) your
              violation of any term of these Terms of Service; (ii) your
              violation of any third party right, including without limitation
              any copyright, property, privacy right, or any and all intangible
              or intellectual property rights; or (iii) any claim that any of
              your UGC causes damage to a third party.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Dispute Resolution
            </h2>
            <p className="text-gray-600 mb-6">
              For the purposes of this Section, references to "Trademark Law
              Associates," "you," and "us" include our respective subsidiaries,
              affiliates, agents, employees, business partners, predecessors in
              interest, successors, and assigns, as well as all authorized or
              unauthorized users or beneficiaries of services or products under
              these Terms or any prior agreements between us. In this Agreement,
              Dispute is defined as "any dispute, claim or controversy between
              you and Trademark Law Associates, its members, officers,
              directors, agents, parent companies and vendors that arises out of
              or relates to this Agreement or use of the Site or Service, or
              otherwise regarding any aspect of your relationship with Trademark
              Law Associates that has accrued or may thereafter accrue, whether
              based in contract, statute (including, but not limited to, any
              consumer protection statutes, regulation, ordinance, tort
              (including, but not limited to, fraud, misrepresentation,
              fraudulent inducement, negligence or any other intentional tort),
              or any other legal or equitable theory."
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Arbitration
            </h2>
            <p className="text-gray-600 mb-6">
              Any Dispute shall be FINALLY and EXCLUSIVELY resolved by binding
              individual arbitration conducted by the American Arbitration
              Association ("AAA") under its Consumer Arbitration Rules. This
              arbitration agreement is made pursuant to a transaction involving
              interstate commerce, and shall be governed by the Federal
              Arbitration Act (9 U.S.C. 1-16). ARBITRATION OF YOUR CLAIM IS
              MANDATORY AND BINDING. NEITHER PARTY WILL HAVE THE RIGHT TO
              LITIGATE THAT CLAIM THROUGH A COURT. IN ARBITRATION, NEITHER PARTY
              WILL HAVE THE RIGHT TO A JURY TRIAL OR TO ENGAGE IN DISCOVERY,
              EXCEPT AS PROVIDED FOR IN THE AAA CODE OF PROCEDURE.
            </p>
            <p className="text-gray-600 mb-6">
              All determinations as to the scope, interpretation, enforceability
              and validity of this Agreement shall be made final exclusively by
              the arbitrator, which award shall be binding and final. Judgment
              on the arbitration award may be entered in any court having
              jurisdiction. This arbitration provision shall survive: i) the
              termination of the Agreement; or ii) the bankruptcy of any party.
              If any portion of this arbitration provision is deemed invalid or
              unenforceable, the remaining portions shall remain in force. NO
              CLASS ACTION, OR OTHER REPRESENTATIVE ACTION OR PRIVATE ATTORNEY
              GENERAL ACTION OR JOINDER OR CONSOLIDATION OF ANY CLAIM WITH A
              CLAIM OF ANOTHER PERSON OR CLASS OF CLAIMANTS SHALL BE ALLOWABLE.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              RIGHT TO OPT-OUT
            </h2>
            <p className="text-gray-600 mb-6">
              You may opt-out of arbitration by notifying us of your decision to
              reject the arbitration clause in writing. You must notify us in
              writing within 30 days of accepting this Agreement. Failure to do
              so will make this Agreement binding on you.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Copyright Notice
            </h2>
            <p className="text-gray-600 mb-6">
              If you believe your copyright has been violated, please send a
              notification in accordance with the Digital Millennium Copyright
              Act (17 U.S.C. § 512(c)(3)) to info@trademarklawassociates.com or
              to the designated copyright agent on record with the U.S.
              Copyright Office, with the subject line: "Copyright Notice." Your
              notification should include: (1) A physical or electronic
              signature of the person authorized to act on behalf of the
              copyright owner; (2) Identification of the copyrighted work
              alleged to have been infringed or, if multiple works are involved,
              a representative list of such works at the relevant site; (3) A
              description of the allegedly infringing material, specifying its
              location, and enough information to help the service provider find
              it; (4) Sufficient contact details, such as an address, phone
              number, and email address, if available; (5) A statement of good
              faith belief that the material is used without authorization from
              the copyright holder, their agent, or the law; (6) A statement
              that the provided information is accurate, and under penalty of
              perjury, that you are authorized to act on behalf of the copyright
              holder.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Payment Terms
            </h2>
            <p className="text-gray-600 mb-6">
              Service fee is non-refundable if the refund is requested after the
              Clearance and Search Report has been provided. Partial fee is
              refundable if the client signs up and immediately requests a
              refund, even if the Clearance and Search Report has not yet been
              provided.
            </p>
            {/* 
            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">Refund Policy</h2>
            <p className="text-gray-600 mb-6">
              All packages include attorney-conducted searches and are non-refundable. Once a search and clearance report is issued, payment will be automatically processed within 24-48 hours if we do not receive a response from you via email or phone. The payment will be transferred to the USPTO (United States Patent and Trademark Office) through the attorney.
            </p> */}

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Authorization
            </h2>
            <p className="text-gray-600 mb-6">
              By submitting an order, you authorize us to receive correspondence
              from the USPTO related to your trademarks alongside you. While you
              can revoke this at any time, including us in communications helps
              us assist you better and may be necessary for services such as
              monitoring and scheduling.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Entire Agreement
            </h2>
            <p className="text-gray-600 mb-6">
              This Agreement, together with the Privacy Policy, represents the
              complete and exclusive agreement between the parties regarding the
              subject matter herein. No waiver of any breach or default by
              either party constitutes a waiver of any prior or subsequent
              breach or default.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Modifications to the Agreement
            </h2>
            <p className="text-gray-600 mb-6">
              We retain the right to modify or discontinue any of these terms
              and/or the Privacy Policy at any time, as we deem necessary.
              Changes may include the introduction of new fees or charges. We
              may, but are not required to, notify you of significant changes
              through email or by posting a notice on the Website. Any
              modifications will be effective when we send an email notice to
              you or post the changes on the Website, whichever comes first. We
              recommend periodically reviewing this section of the Website to
              stay updated on any modifications. Continued use of the Website
              after such notice shall be deemed as acceptance of the changes.
            </p>

            <h2 className="text-4xl font-bold text-gray-800 mt-12 mb-6">
              Miscellaneous
            </h2>
            <p className="text-gray-600 mb-6">
              We reserve the right to limit the sale of our products or services
              to any individual, location, or jurisdiction, at our discretion,
              on a case-by-case basis. Product descriptions and pricing may
              change without notice, at our sole discretion. We also reserve the
              right to discontinue any product at any time. Offers made on this
              website are void where prohibited. Section headings are provided
              for convenience only and do not carry legal significance. If any
              part of this Agreement is found invalid by a court of competent
              jurisdiction, the remainder of the Agreement will remain valid and
              enforceable. This Agreement does not confer any third-party
              benefits. You may not assign your rights or obligations under this
              Agreement to any third party without our prior written consent,
              and any unauthorized assignment will be invalid.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsConditions;
